import { getNewRelic } from '@/lib/newrelic';
import { getErrorContext } from '@/lib/newrelic/context/errorContext';

/**
 * Reports an error to New Relic with the current error context (URL params, user type, user ID, page template) merged with any extra attributes. Use this for consistent context on all reported errors.
 */
export function reportErrorToNewRelic(
  error: Error,
  extraAttributes?: Record<string, string | number | boolean>
): void {
  const newrelic = getNewRelic();
  if (newrelic) {
    const customAttributes: Record<string, string | number | boolean> = {
      ...getErrorContext(),
      ...extraAttributes,
    };
    newrelic.noticeError(error, customAttributes);
  }
}
